/**
 * Set of data and computeds to work well with Pagination components.
 *
 * pagintationEntities is a getter on real component which returns a pointer
 * to the array to paginate
 */
var mixins = {
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
    };
  },
  computed: {
    queriedData() {
      if (this.paginationEnabled && Array.isArray(this.paginationEntities)) {
        return this.paginationEntities.slice(this.from, this.to);
      }

      return this.paginationEntities;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return Array.isArray(this.paginationEntities)
        ? this.paginationEntities.length
        : 0;
    }
  }
};

export default mixins;
